import { createContext, MutableRefObject, useCallback, useContext } from 'react';
import { ShortcutsConfig, UserDefinedShortcutsConfig } from '..';
import { getActionsByKey } from '../utils';
import { getKey } from '../KeyHelper';
import defaultShortcuts from '../data/default.json';

export const KeyboardShortcutsContext = createContext<{
  shortcuts: ShortcutsConfig;
  saveShortcuts: (userDefined: UserDefinedShortcutsConfig) => void;
  actionCache: MutableRefObject<Record<string, string[]>>;
}>({
  shortcuts: defaultShortcuts,
  saveShortcuts: () => {},
  actionCache: { current: {} },
});

export const useKeyboardShortcuts = () => {
  const { shortcuts, actionCache } = useContext(KeyboardShortcutsContext);

  const getActionsByKeyEvent = useCallback(
    (e: KeyboardEvent) => {
      const key = getKey(e);
      if (actionCache.current[key] === undefined) {
        actionCache.current[key] = getActionsByKey(key, shortcuts);
      }
      return {
        key,
        actions: actionCache.current[key],
      };
    },
    [actionCache, shortcuts]
  );

  return {
    getActionsByKeyEvent,
  };
};
